import React from 'react';
import { useIntl } from 'react-intl';

import { Event } from 'app/shared/typings';
import { AdminHeaderControls } from 'app/fan/components/molecules';

export const AdminHeader: React.FC<
  React.PropsWithChildren<{ event?: Event }>
> = ({ event }) => {
  const { formatMessage } = useIntl();
  const eventId = event?.id;
  const city = event?.city;
  const cityId = city?.id;
  const cityUrlParam =
    city && city.cachedSlug && city.cachedSlug.replace('_', '-');

  if (!event) {
    return (
      <AdminHeaderControls
        buttonsConfig={[]}
        resourceId={cityId}
        permissionName="event.list.view"
      />
    );
  }

  const buttonsConfig = [
    {
      href: `/admin/concert-planner?city=${cityUrlParam}&event_id=${eventId}`,
      text: formatMessage({ id: 'admin.adminHeaderControls.manageEvent' }),
    },
  ];

  return (
    <AdminHeaderControls
      resourceId={cityId}
      permissionName="event.list.view"
      buttonsConfig={buttonsConfig}
    />
  );
};
